import { FC, PropsWithChildren } from 'react';
import { EventRegistrationProvider } from '../../../../../../shared/frontend/scripts/events/providers/EventRegistrationProvider';
import {
  MediaContextProvider,
  MediaContextProviderV2
} from '../../../../../../shared/frontend/components/presentational/media';
import { InStreamVideoEligibilityProvider } from '../../../../../../shared/frontend/components/ads/instreamVideoContext';
import { VideoPlacementProviders } from '../../../../../../shared/frontend/components/ads/videoPlacementProviders';

// Fresnel 8.x handles React 18 hydration internally (Media renders with
// suppressHydrationWarning on the first client pass). Do NOT toggle
// disableDynamicMediaQueries after hydration: its two branches render
// different root element types, so flipping it unmounts and remounts the
// entire app tree below this provider.
export const CommonProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <MediaContextProvider>
      <MediaContextProviderV2>
        <InStreamVideoEligibilityProvider>
          <VideoPlacementProviders>
            <EventRegistrationProvider>{children}</EventRegistrationProvider>
          </VideoPlacementProviders>
        </InStreamVideoEligibilityProvider>
      </MediaContextProviderV2>
    </MediaContextProvider>
  );
};
